import './boot.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App/App.js';
import ErrorBoundary from './App/ErrorBoundary.js'; // Import the ErrorBoundary component
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './App/ThemeContext';
import { Buffer } from 'buffer'
import CookieConsent, { resetCookieConsentValue } from "react-cookie-consent";
import {parseKBSubdomain} from "./App/utils";
import {PromptProvider} from "./Components/PromptContext";
import {ConfirmProvider} from "./Components/ConfirmContext";

window.Buffer = Buffer;

const root = ReactDOM.createRoot(document.getElementById('root'));
const parsedSubdomain = parseKBSubdomain();
const isInIframe = window.self !== window.top;

root.render(
    <ErrorBoundary> {/* Wrap your components with ErrorBoundary */}
        <ThemeProvider>
            <BrowserRouter>
                {!parsedSubdomain && !isInIframe && (
                    <CookieConsent
                        style={{ background: "white", color: "black", zIndex: 10000 }}
                        buttonStyle={{ background: "white", color: "black", border: "1px solid black" }}
                    >
                        This website uses cookies to enhance the user experience.
                    </CookieConsent>
                )}
                <PromptProvider>
                    <ConfirmProvider>
                        <App />
                    </ConfirmProvider>
                </PromptProvider>
            </BrowserRouter>
        </ThemeProvider>
    </ErrorBoundary>
);

reportWebVitals();

// Check if service workers are supported
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js', { scope: '/' })
            .then((registration) => {
                // Registration was successful
                console.log('ServiceWorker registration successful with scope: ', registration.scope);
            })
            .catch((err) => {
                // Registration failed
                console.log('ServiceWorker registration failed: ', err);
            });
    });
}